export default __webpack_public_path__ + "static/media/chef.1ca9b2a4.svg";